import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import {
  selectActiveApplication,
  selectActiveUserId
} from 'features/applications/applicationsSelectors';
import applicationsService from 'features/applications/applicationsService';

import useErrorCatch from 'hooks/useErrorCatch';

import { InterviewDetails } from 'types/interviewSlots';

export const useInterviewState = () => {
  const catchError = useErrorCatch();
  const applicationId = useSelector(selectActiveUserId);
  const application = useSelector(selectActiveApplication);
  const [isLoading, setIsLoading] = useState(false);
  const [interviewRequest, setInterviewRequest] =
    useState<InterviewDetails | null>(null);

  const isInterviewRequestSent = application?.interviewRequestSent;

  const fetchInterviewRequest = async () => {
    try {
      const response =
        await applicationsService.getApplicationInterviewRequest(applicationId);

      setInterviewRequest(response.at(-1) || null);
    } catch (error) {
      catchError({ error });
    }
  };

  useEffect(() => {
    if (applicationId) {
      if (isInterviewRequestSent) {
        fetchInterviewRequest();
      } else {
        setInterviewRequest(null);
      }
    }
  }, [applicationId, isInterviewRequestSent]);

  return {
    applicationId,
    isLoading,
    setIsLoading,
    interviewRequest,
    isInterviewRequestSent,
    fetchInterviewRequest
  };
};
